import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import dotoodVilAjillagaa from "../../api/dotood-surgalt";
import { useParams } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Mcc from "../../components/mcc/Mcc";
import Footer from "../../components/footer/Footer";

const DotoodSurgaltZadargaa = ({ isDark, onToggleDark }) => {
  const { slug } = useParams();
  const dotoodSurgaltDetails = dotoodVilAjillagaa.find(
    (item) => item.slug === slug
  );

  return (
    <Fragment>
      <Header isDark={isDark} hclass={"header--styleFour"} />
      <main className="main">
        <PageTitle
          pageTitle={dotoodSurgaltDetails.title}
          pagesub={"дотоод-үйл-ажиллагаа" + " / " + dotoodSurgaltDetails.slugMn}
          pageTop={"Portfolio"}
          tolink={"#dsurgalt"}
        />

        <section id="dsurgalt" className="stories pt-70 pb-20">
          <div className="container">
            <div className="row">
              <Mcc />
              <div className="col-lg-12 pb-30">
                <div className="innerWrapper">
                  <div className="donationDetails storiesDetails">
                    <div className="donationDetails__header mb-45">
                      <figure className="thumb mb-45">
                        <img src={dotoodSurgaltDetails.img1} alt="mcc" />
                      </figure>
                    </div>
                    {dotoodSurgaltDetails.bigtitle ? (
                      <h4 className="donationDetails__heading mb-25">
                        {dotoodSurgaltDetails.bigtitle}
                      </h4>
                    ) : null}
                    <p className="donationDetails__text storiesDetails__text storiesDetails__text--first mb-30">
                      {dotoodSurgaltDetails.description}
                    </p>
                    <p className="donationDetails__text mb-30">
                      {dotoodSurgaltDetails.description2}
                    </p>
                    {dotoodSurgaltDetails.img2 ? (
                      <div className="row">
                        <div className="col-lg-6 text-center">
                          <figure className="thumb mb-35">
                            <img src={dotoodSurgaltDetails.img2} alt="mcc" />
                          </figure>
                        </div>
                        {dotoodSurgaltDetails.img3 ? (
                          <div className="col-lg-6 text-center">
                            <figure className="thumb mb-35">
                              <img src={dotoodSurgaltDetails.img3} alt="mcc" />
                            </figure>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <Mcc />
            </div>
          </div>
        </section>
      </main>
      <Footer isDark={isDark} onToggleDark={onToggleDark} />
      <Scrollbar />
    </Fragment>
  );
};
export default DotoodSurgaltZadargaa;

// import React, { Fragment, useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { supabase } from "../../supabaseClient";

// import Header from "../../components/header/Header";
// import PageTitle from "../../components/pagetitle/PageTitle";
// import Scrollbar from "../../components/scrollbar/scrollbar";
// import Mcc from "../../components/mcc/Mcc";
// import Footer from "../../components/footer/Footer";

// const DotoodSurgaltZadargaa = ({ isDark, onToggleDark }) => {
//   const { slug } = useParams();
//   const [event, setEvent] = useState(null);

//   useEffect(() => {
//     const fetchEvent = async () => {
//       // 1️⃣ JSON татах
//       // 1️⃣ JSON файлд signed URL үүсгэх
//       const { data: signed, error: urlError } = await supabase.storage
//         .from("assets-backet") // bucket нэр зөв байх ёстой
//         .createSignedUrl("data/dotoodVilAjillagaa.json", 300); // 5 минут хүчинтэй

//       console.log("Signed URL:", signed);

//       if (urlError) {
//         console.error(urlError.message);
//         return;
//       }

//       // 2️⃣ fetch ашиглан JSON татах
//       const res = await fetch(signed.signedUrl);
//       if (!res.ok) {
//         console.error("JSON татахад алдаа гарлаа");
//         return;
//       }

//       const json = await res.json();

//       // 2️⃣ slug-аар filter хийх
//       const item = json.find((i) => i.slug === slug);
//       if (!item) return;

//       // 3️⃣ Зураг бүрийг signed URL болгох
//       const imgKeys = ["img1", "img2", "img3"];
//       for (let key of imgKeys) {
//         if (item[key]) {
//           const { data: signed, error: imgError } = await supabase.storage
//             .from("assets-backet")
//             .createSignedUrl(item[key], 300); // 5 минут хүчинтэй

//           if (!imgError) item[key] = signed.signedUrl;
//         }
//       }

//       setEvent(item);
//     };

//     fetchEvent();
//   }, [slug]);

//   if (!event) return <p>Уншиж байна...</p>;

//   return (
//     <Fragment>
//       <Header isDark={isDark} hclass={"header--styleFour"} />
//       <main className="main">
//         <PageTitle
//           pageTitle={event.title}
//           pagesub={"дотоод-үйл-ажиллагаа / " + event.slugMn}
//           pageTop={"Portfolio"}
//           tolink={"#dsurgalt"}
//         />

//         <section id="dsurgalt" className="stories pt-70 pb-20">
//           <div className="container">
//             <div className="row">
//               <Mcc />
//               <div className="col-lg-12 pb-30">
//                 <div className="innerWrapper">
//                   <div className="donationDetails storiesDetails">
//                     {/* Гол зураг */}
//                     <div className="donationDetails__header mb-45">
//                       {event.img1 && (
//                         <figure className="thumb mb-45">
//                           <img src={event.img1} alt={event.title} />
//                         </figure>
//                       )}
//                     </div>

//                     {/* Гарчиг */}
//                     {event.bigtitle && (
//                       <h4 className="donationDetails__heading mb-25">
//                         {event.bigtitle}
//                       </h4>
//                     )}

//                     {/* Тайлбар */}
//                     <p className="donationDetails__text storiesDetails__text storiesDetails__text--first mb-30">
//                       {event.description}
//                     </p>
//                     <p className="donationDetails__text mb-30">
//                       {event.description2}
//                     </p>

//                     {/* Нэмэлт зураг */}
//                     {(event.img2 || event.img3) && (
//                       <div className="row">
//                         {event.img2 && (
//                           <div className="col-lg-6 text-center">
//                             <figure className="thumb mb-35">
//                               <img src={event.img2} alt={event.title} />
//                             </figure>
//                           </div>
//                         )}
//                         {event.img3 && (
//                           <div className="col-lg-6 text-center">
//                             <figure className="thumb mb-35">
//                               <img src={event.img3} alt={event.title} />
//                             </figure>
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <Mcc />
//             </div>
//           </div>
//         </section>
//       </main>

//       <Footer isDark={isDark} onToggleDark={onToggleDark} />
//       <Scrollbar />
//     </Fragment>
//   );
// };

// export default DotoodSurgaltZadargaa;
